import React, { ReactNode } from 'react';
/*
  The Cookbook FormInput component passes a series for props to any children passed into it, which are not valid html element attributes. 
  This results in a mass amount of "React does not recognize 'X' prop on a DOM element" when html dom elements are passed in as children to FormInput.
  These props (inputSize, validationStatus, fixedWidth, blockWidth) are intended to be passed to other CB components that support those props.
  Largely this is done to enforce a consistent look for the Label, Input, and ValidationMessage.
  
  This FormInputContentWrapper is intended as a passthrough component to prevent the react warnings, without introducing any styling or behavioral changes.
  This component can be deleted once
  - Children of FormInput in this repo are updated to use cookbook components
  - Cookbook introduces a mechanism to prevent passing these props to components that do not support them.
*/

interface IFormInputContentWrapper {
  children: ReactNode;
}

export function FormInputContentWrapper({
  children,
}: IFormInputContentWrapper): JSX.Element {
  return <>{children}</>;
}
